<template>
  <div class="container" :class="isStyleApplied?'eyes_container':''">
    <!-- <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%"> -->
    <div
      style="width: 100%; height: 100%"
      :class="
        dialogType === '飞行报告' ||
        dialogType === '航线' ||
        dialogType === '航点'
          ? 'big'
          : 'small'
      "
    >
      <el-dialog
        :modal="modal"
        :visible="dialogVisibleInternal"
        :before-close="handleClose"
        :title="dialogTitle"
        :width="
          dialogType === '飞行报告' ||
          dialogType === '航线' ||
          dialogType === '航点'
            ? '95%'
            : '50%'
        "
        :close-on-click-modal="false"
      >
        <div class="content">
          <el-form
            :label-position="labelPosition"
            :label-width="labelWidth"
            :model="formModel"
            ref="formRef"
            @submit.native.prevent="handleSubmit"
            :rules="generatedRules"
          >
            <!-- 表单内容插槽 -->
            <slot></slot>
          </el-form>
          <div
            slot="footer"
            :class="
              dialogType === '飞行报告' ||
              dialogType === '航线' ||
              dialogType === '航点'
                ? 'bottomBtn1'
                : 'bottomBtn'
            "
          >
            <el-button
              type="text"
              class="btnTxt"
              @click="handleSubmit"
              :loading="btnLoading"
            >
              <span style="color: #fff">{{ btnName }}</span>
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

    <script>


export default {
  name: "BasicForm",

  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    labelWidth: {
      type: String,
      required: false,
      default: '140px',
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    dialogType: {
      type: String,
      required: false,
    },
    modal: {
      type: Boolean,
      required: false,
      default: true,
    },
    formModel: {
      type: Object,
      required: true,
    },
    btnName: {
      type: String,
      required: false,
      default: "提交",
    },
    // 按钮加载状态
    btnLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 表单必填校验
    formRules: {
      type: Array,
      required: true,
    },
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
  },
  emit: [],
  data() {
    return {
      dialogVisibleInternal: this.dialogVisible,
      temporaryRules: {}, // 新增一个临时存放校验规则的属性
    };
  },
  mounted() {},
  watch: {
    dialogVisible(newVal) {
      this.dialogVisibleInternal = newVal;
    },
  },
  methods: {
    handleSubmit() {
      // return
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 表单通过校验，提交表单数据到父组件
          this.$emit("submit", this.formModel);
          // this.$refs.formRef.resetFields();
          //console.log('提交的数据--->', this.formModel)
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("update:dialogVisible", false); // 向父组件发送事件
      this.$refs.formRef.resetFields();
    },
  },
  computed: {
    generatedRules() {
      const rules = {};
      this.formRules.forEach((item) => {
        const message =
          item.prop === "pic" ? `请上传${item.label}` : `请填写${item.label}`;
        rules[item.prop] = [{ required: true, message, trigger: "blur" }];
      });
      return rules;
    },
  },
};
</script>
    <style scoped>
@import "../../src/assets/css/common/BasicForm.css";
</style>



// WEBPACK FOOTER //
// src/common/BasicForm.vue